import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LoadingService } from '@core/services/loading.service';
import { Observable, tap, finalize } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NetwordActivityInterceptor implements HttpInterceptor {
  private loadingSrv = inject(LoadingService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let requestStarted = false;

    return next.handle(req).pipe(
      tap(event => {
        if (event.type === HttpEventType.Sent) {
          requestStarted = true;
          this.loadingSrv.show();
        }

        return event;
      }),
      finalize(() => {
        // Only hide if we actually showed the spinner
        if (requestStarted) {
          this.loadingSrv.hide(750);
        }
      })
    );
  }
}
